/* _mtmLoaded ensures the script loads only once, even if the user navigates or reloads the component.
trackPageView pushes a page view event to the Matomo Tag Manager.
*/
let _mtmLoaded = false;

export function loadMatomo() {
  if (_mtmLoaded) return;
  _mtmLoaded = true;

  var _mtm = (window._mtm = window._mtm || []);
  _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });

  const d = document;
  const g = d.createElement("script");
  const s = d.getElementsByTagName("script")[0];
  g.async = true;
  g.src = "https://site-analytics.nlpli.ilsp.gr/js/container_yB7dwyzp.js";
  //g.src = "https://language-data-space.eu/analytics/js/container_JGuLuJ9e.js";
  s.parentNode.insertBefore(g, s);
}

// Call this whenever the route changes
export function trackPageView(url) {
  if (window._mtm) {
    window._mtm.push({ event: "mtm.PageView", url });
  }
}
